<template>
  <ModuleContainer v-bind="bindModule">
    <template #draggable>
      <DraggablePopup
        :show.sync="show"
        title="Thông tin chi tiết"
        :top="140"
        :width="400"
        :right="60"
        :height="heightInfo"
        style="position: relative;"
      >
        <template #extra-btn>
          <v-btn icon small @click.stop="prepareExport" title="Kết xuất dữ liệu/bản đồ">
            <v-icon small color="white">mdi-export</v-icon>
          </v-btn>
        </template>
        <div style="padding-bottom: 30px;" ref="resultInfo">
          <ResultFeature
            :value="value"
            :fields="fieldShowMore"
            v-if="isShowMore"
          />
          <ResultFeature :value="value" :fields="fields" v-else />
        </div>
        <div
          class="d-flex align-center show-more-fields"
          @click="handleShowMore"
          v-if="fieldShowMore.length > fields.length"
        >
          <v-icon medium color="darken-2">
            {{ isShowMore ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
          {{ isShowMore ? 'Thu gọn' : 'Xem thêm' }}
        </div>
      </DraggablePopup>
    </template>
    <slot />
    <ExportFeatureDialog 
      :show.sync="showExportDialog"
      :fields="fields"
      :featureData="value"
      :previewImage="previewImage"
    />
  </ModuleContainer>
</template>

<script>
import { callRef } from '@/src/utils'
import { DraggablePopup } from '@components/draggable'
import ModuleMixin from '@components/Map/mixins/ModuleMixin'
import ResultFeature from '@components/search/result/result-feature.vue'
import ExportFeatureDialog from '@components/search/result/ExportFeatureDialog.vue'
import { fitBounds } from '@utils/helper-map'

export default {
  components: { DraggablePopup, ResultFeature, ExportFeatureDialog },
  mixins: [ModuleMixin],
  props: {},
  data() {
    return {
      fields: [],
      value: {},
      show: false,
      showExportDialog: false,
      previewImage: null,
      isShowMore: false,
      fieldShowMore: [],
      heightInfo: 500,
    }
  },
  watch: {},
  computed: {},
  methods: {
    open({ data, fields } = {}) {
      this.fields = fields.filter(
        (el) => el.visibility.browse && !el.visibility.inShowMore
      )
      this.fieldShowMore = fields.filter((el) => el.visibility.browse)
      this.fields.sort((a, b) => a.order - b.order)
      this.fieldShowMore.sort((a, b) => a.order - b.order)
      this.isShowMore = false
      this.value = data
      this.show = true
      setTimeout(() => {
        callRef(
          () => {
            const heightContent = this.$refs.resultInfo?.offsetHeight
            this.heightInfo = heightContent < 400 ? heightContent + 60 : 400
          },
          () => this.$refs.resultInfo
        )
      })
    },
    handleShowMore() {
      this.isShowMore = !this.isShowMore
      setTimeout(() => {
        callRef(
          () => {
            const heightContent = this.$refs.resultInfo?.offsetHeight
            if (this.isShowMore) {
              this.heightInfo = heightContent < 550 ? heightContent + 60 : 550
            } else {
              this.heightInfo = heightContent < 400 ? heightContent + 60 : 400
            }
          },
          () => this.$refs.resultInfo
        )
      }, 50)
    },
    async prepareExport() {
      if (!this.map) return;
      
      // 1. Tự động lấy tâm đối tượng và FlyTo (giống nút Bay Tới ở màn ngoài)
      const geom = this.value?.geometry || this.value?.feature?.geometry;
      if (geom) {
        try {
          fitBounds(this.map, geom);
          // Đợi 800ms để bản đồ bay tới và render xong nét căng
          await new Promise(resolve => setTimeout(resolve, 800));
        } catch (e) {
          console.warn('Không thể fitBounds tới đối tượng', e);
        }
      }

      // 2. Chụp ngay 1 bức ảnh vào khoảnh khắc này (trước khi người dùng kịp zoom đi chỗ khác)
      try {
        this.previewImage = this.map.getCanvas().toDataURL("image/png");
      } catch (err) {
        console.error("Lỗi khi chụp ảnh preview:", err);
      }

      // 3. Mở Dialog
      this.showExportDialog = true;
    }
  },
}
</script>
<style scoped>
.show-more-fields {
  height: 30px;
  width: 100%;
  background: #f7f9f9;
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: pointer;
  padding-left: 10px;
  color: gray;
}

.show-more-fields:hover {
  background: #f4f6f7;
}
</style>
